import { getToken,axiosInstance } from "../utils/Api";
export const getAllRoles = async () =>{ 
    try {
        const response = await axiosInstance.get("/admin/roles/getAllRoles",{
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        });
        return response.data;
      } catch (error) {
        throw error;
      } 
}
 
export const getAllAcls = async () =>{ 
  try {
      const response = await axiosInstance.get("/admin/ACL/getACl",{
          headers: {
              Authorization: `Bearer ${getToken()}`,
          },
      });
      return response.data;
    } catch (error) {
      throw error;
    } 
}

export const createACl = async (params) =>{ 
  try {
      const response = await axiosInstance.post("/admin/ACL/createACl",params,{
          headers: {
              Authorization: `Bearer ${getToken()}`,
          },
      });
      return response.data;
    } catch (error) {
      throw error;
    } 
}

export const deleteACl = async (params) =>{ 
  try {
      const response = await axiosInstance.delete("/admin/ACL/deleteACl",{
          headers: {
              Authorization: `Bearer ${getToken()}`,
          },
          data : params ,
      });
      return response.data;
    } catch (error) {
      throw error;
    } 
}

export const createRole = async (data) =>{ 
  try {
      const response = await axiosInstance.post(`/admin/roles/createrole`,data,{
          headers: { 
              Authorization: `Bearer ${getToken()}`,
          }
      });
      return response.data;
    } catch (error) {
      throw error;
    } 
} 

export const getRoleDetails = async (id) =>{ 
  try {
      const response = await axiosInstance.get(`admin/roles/getRoles?id=${id}`,{
          headers: { 
              Authorization: `Bearer ${getToken()}`,
          }
      });
      return response.data;
    } catch (error) {
      throw error;
    } 
}  

export const updateRole = async (updateData) =>{ 
  try {
      const response = await axiosInstance.put("/admin/roles/updaterole",updateData,{
          headers: {  
              Authorization: `Bearer ${getToken()}`,
          }
      });
      return response.data;
    } catch (error) {
      throw error;
    } 
} 
